import axios from 'axios'

import { API_URL, API_URL_DEV } from '../config/appConfig'
import { CLEAR_ERRORS, GET_ERRORS } from 'redux/types';
import { IRequestConfig } from '../interfaces/INetWork'

import { configUserFromResponse } from './axiosFunctions'

const axiosFunctionTypes = {
    POST: 'POST',
    GET: 'GET',
    DELETE: 'DELETE',
    PUT: 'PUT'
}

export const post = async (dispatch, requestConfig: IRequestConfig) => {
    return await getAxiosResponse(
        axiosFunctionTypes.POST,
        dispatch,
        requestConfig
    )
}


export const get = async (dispatch, requestConfig: IRequestConfig) => {
    if(requestConfig.data) {
        requestConfig.data = {
            params: requestConfig.data
        }
    }
    return await getAxiosResponse(
        axiosFunctionTypes.GET,
        dispatch,
        requestConfig
    )
}


export const put = async (dispatch, requestConfig: IRequestConfig) => {
    return await getAxiosResponse(
        axiosFunctionTypes.PUT,
        dispatch,
        requestConfig
    )
}


export const deletefn = async (dispatch, requestConfig: IRequestConfig) => {
    return await getAxiosResponse(
        axiosFunctionTypes.DELETE,
        dispatch,
        requestConfig
    )
}

const getAxiosResponse = async (actionType: string, dispatch, requestConfig: IRequestConfig) => {
    let response = null;
    if (requestConfig.loadingType) {
        dispatch({
            type: requestConfig.loadingType
        })
    }
    if (!requestConfig.delayType) {
        requestConfig.delayType = null;
    }
    if (requestConfig.delay && [null, 'START'].includes(requestConfig.delayType)) {
        await asyncDelay(requestConfig.delay)
    }
    try {
        let axiosResponse = null;
        switch (actionType) {
            case axiosFunctionTypes.POST:
                axiosResponse = await axios.post(
                    getApiURL(requestConfig.url),
                    requestConfig.data,
                    requestConfig.axiosConfig
                )
                break;

            case axiosFunctionTypes.PUT:
                axiosResponse = await axios.put(
                    getApiURL(requestConfig.url),
                    requestConfig.data,
                    requestConfig.axiosConfig
                )
                break
            case axiosFunctionTypes.GET:
                axiosResponse = await axios.get(
                    getApiURL(requestConfig.url),
                    requestConfig.data || {}
                )
                break;

            case axiosFunctionTypes.DELETE:
                axiosResponse = await axios.delete(
                    getApiURL(requestConfig.url), {
                    ...(requestConfig.axiosConfig || {}),
                    data: requestConfig.data || {}
                }
                )
                break;
            default:
                break;
        }
        if (requestConfig.successType) {
            if(requestConfig.successPayload) {
                dispatch({
                    type: requestConfig.successType,
                    payload: requestConfig.successPayload
                })
            } else {
                dispatch({
                    type: requestConfig.successType,
                    payload: axiosResponse.data.data
                })
            }
        }
        configUserFromResponse(axiosResponse?.data, dispatch)
        clearErrors(dispatch)
        response = axiosResponse?.data
        if (response) {
            response.success = true
        }
    } catch (err) {
        console.log(err)
        response = getErrors(dispatch, err)
        if (requestConfig.errorType) {
            dispatch({
                type: requestConfig.errorType
            })
        }
    }
    return response;
}


const getErrors = (dispatch, errorResponse) => {
    let payload = {};
    if (
        errorResponse.response &&
        errorResponse.response.data &&
        typeof errorResponse.response.data.data !== "undefined"
    ) {
        payload = errorResponse.response.data.data;
    }

    if (
        errorResponse.response &&
        errorResponse.response.data &&
        typeof errorResponse.response.data.error !== "undefined"
    ) {
        payload = {
            ...payload,
            error: errorResponse.response.data.error,
        };
    }

    if (errorResponse.response && errorResponse.response.data) {
        configUserFromResponse(errorResponse.response, dispatch);
    }

    dispatch({
        type: GET_ERRORS,
        payload,
    });

    if (errorResponse.response && errorResponse.response.data) {
        return errorResponse.response.data;
    }
};

export const clearErrors = (dispatch) => {
    dispatch({
        type: CLEAR_ERRORS
    })
}

export const getApiURL = (strURL: string) => {
    if (typeof window.location === 'undefined') {
        return `${API_URL}${strURL}`
    }
    if (window.location.origin.indexOf('localhost') >= 0) {
        return `${API_URL_DEV}${strURL}`
    }
    return `${API_URL}${strURL}`
}

export const asyncDelay = (miliseconds: number) => {
    return new Promise((resolve) => {
        setTimeout(resolve, miliseconds)
    })
}